export default __webpack_public_path__ + "static/bg-b3f7fd98eed5566381ec0382e2cddd9c.png";